import { render, staticRenderFns } from "./indexs1.vue?vue&type=template&id=392e194d&scoped=true&"
import script from "./indexs1.vue?vue&type=script&lang=js&"
export * from "./indexs1.vue?vue&type=script&lang=js&"
import style0 from "./indexs1.vue?vue&type=style&index=0&id=392e194d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e194d",
  null
  
)

export default component.exports